import useUser from "@hooks/useUser";

const useLanguage = (langOverride?: Language): Language => {
  const { user } = useUser();
  return langOverride || user?.language || "en";
};

export default useLanguage;
